export default __webpack_public_path__ + "static/media/shield.885dc360.svg";